import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
gsap.registerPlugin(CustomEase);

window.addEventListener('load', function () {

	const banner = document.querySelector('.page-banner');

	if( banner ) {

		const bannerOverlay = banner.querySelector('.page-banner__overlay');
		const bannerText = banner.querySelector('.page-banner__content');

		bannerOverlay.style.visibility = 'visible';
		bannerText.style.visibility = 'visible';

		const bannerTL = gsap.timeline({delay:0.5});
		bannerTL.fromTo(bannerOverlay,{
	  	opacity:0, 
	  },{
	  	opacity:1,
	  	duration:1 
	  })
	  .fromTo(bannerText,{
	  	opacity:0, 
	  },{
	  	opacity:1,
	  	duration:1 
	  });

	}

}, false);